<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Edit Subscriptions">
      <div class="row">
        <div class="col-md-6 form-group">
          Category Name
          <input
            class="form-control"
            type="text"
            v-model="category"
            @focus="categoryEmpty = false"
            readonly
          />
          <div v-if="nameEmpty" style="color: red">
            Categoryname is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Subscription Name
          <input
            class="form-control"
            type="text"
            v-model="name"
            @focus="nameEmpty = false"
          />
          <div v-if="nameEmpty" style="color: red">
            Subscriptionname is required
          </div>
        </div>
       <div class="col-md-6 form-group">
          Validity in (days)
          <input
            class="form-control"
            type="number"
            v-model="validity"
            @focus="validityEmpty = false"
          />
          <div v-if="validityEmpty" style="color: red">
            Validity is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Price
          <input
            class="form-control"
            type="number"
            v-model="price"
            @focus="priceEmpty = false"
          />
          <div v-if="priceEmpty" style="color: red">
            price is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Discount (%)
          <input
            class="form-control"
            type="number"
            v-model="discount"
            @focus="discountEmpty = false"
          />
          <div v-if="discountEmpty" style="color: red">
            Discount is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Image
          <b-form-file id="file-small" v-model="image" @change="image = $event.target.files[0]"></b-form-file>
        </div>
        <div class="col-md-6 form-group">
          Description
          <input
            class="form-control"
            type="text"
            v-model="description"
            @focus="descriptionEmpty = false"
          />
          <div v-if="descriptionEmpty" style="color: red">
            Description is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Subscription Type
          <b-form-select v-model="subscriptiontype" @focus = "subscriptiontypeEmpty = false">
            <option
              v-for="(type, index) in subscriptiontypes"
              :key="index"
              :value="type.value"
            >
              {{ type.text }}
            </option>
          </b-form-select>
          <div v-if="subscriptiontypeEmpty" style="color: red">
            Subscription type is required
          </div>
        </div>

        <div
          v-for="(spec, index) in specs"
          :key="index"
          class="form-group row m-0"
          style="width: 100%"
        >
          <div class="col-md-11 form-group">
            Subscription Specification
            <input v-model="specs[index].specification" class="form-control" />
          </div>
          <div class="col-md-1 form-group">
            <b-button variant="danger" class="mt-4" @click="removespecs(index, specs[index].id)"
              ><i class="fas fa-trash"></i
            ></b-button>
          </div>
        </div>

      </div>
      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          @click="editSubscription()"
          >Save Changes</b-button
        >
      </div>
       <!-- Loader -->
        <b-overlay :show="loader" no-wrap blur="2px" opacity="0.60" class="position-fixed">
          <template #overlay>
            <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
          </template>
        </b-overlay>
    </base-block>
     <br />
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      loader:false,
      subscriptiontypes: [
        {text: "user", value: 1},
        {text: "college", value: 0}
      ],
      specs: [],
      categoryEmpty: false,
      nameEmpty: false,
      validityEmpty: false,
      priceEmpty:false,
      discountEmpty:false,
      descriptionEmpty:false,
      subscriptiontypeEmpty:false,
      categories:[],
      category:"",
      name:"",
      validity:"",
      price:"",
      discount:"",
      description:"",
      subscriptiontype:"",
      image:[],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async removespecs(index, id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true 
      })
      .then(async result => {
        if(result.isConfirmed) {
          await axios
        .get(
          `${this.$store.getters.baseUrl}/specification/delete/${id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then(response => {
          console.log(response);
          if(response.data.status == "success") {
            this.$swal("Success", "specification deleted successfully", "success");
            this.specs.splice(index, 1);
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch(error => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        })
        } else {
          this.$swal("Success", "Your file is safe :)", "success");
        }
      })
    },
     async loadData() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/subscription/edit/${this.$route.params.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.id = response.data.subscription.id;
            this.category = response.data.subscription.category.name;
            this.name = response.data.subscription.name;
            this.validity = response.data.subscription.validity;
            this.price = response.data.subscription.price;
            this.discount = response.data.subscription.discount;
            this.description = response.data.subscription.description;
            this.subscriptiontype = response.data.subscription.subscription_type == 'user' ? 1 : 0
            this.specs = response.data.subscription.subscription_specification
    
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async editSubscription(){
     // alert("gfbgfbg");
      if (this.category == ""){
        this.categoryEmpty = true;
        return;
      }
     
      if (this.name == "") {
        this.nameEmpty = true;
        return;
      }
       
      if (this.validity == "") {
        this.validityEmpty = true;
        return;
      }

       if (this.discount == "") {
        this.discountEmpty = true;
        return;
      }

       if (this.price == "") {
        this.priceEmpty = true;
        return;
      }

       if (this.description == "") {
        this.descriptionEmpty = true;
        return;
      }
      //console.log(this.subscriptiontype)
      /* if (this.subscriptiontype == "") {
        this.subscriptiontypeEmpty = true;
        return;
      }*/
      this.loader = true;
      const formdata = new FormData();
      formdata.append("category", this.category);
      formdata.append("name", this.name);
      formdata.append("validity", this.validity);
      formdata.append("price", this.price);
      formdata.append("discount", this.discount);
      formdata.append("description", this.description);
      formdata.append("image", this.image);
      formdata.append("subscription_type", this.subscriptiontype);
      if (this.specs.length > 0) {
        for (var i = 0; i < this.specs.length; i++) {
          formdata.append(
            "sub_specifications[" + i + "][id]", this.specs[i].id
          );
          formdata.append("sub_specifications[" + i + "][specify]", this.specs[i].specification)
        }
      }
      await axios
        .post(
          `${this.$store.getters.baseUrl}/subscription/update/${this.id}`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
             this.loader = false;
            this.$swal("Success", "Subscription updated successfully", "success");
             this.$router.push({name: 'Subscriptions'});
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },
     async deleteSpecification(id){
      await axios
        .get(`${this.$store.getters.baseUrl}/subscription/sub-edit/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success"){
           this.$swal("Success", "College Subscription deleted successfully", "success");
          }else{
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    },
};
</script>

